// Mock data for agent-native service management
// Primary objects: Case, ActionBundle, Evidence, Policy, Trace

export const cases = [
  {
    id: "case_01HXYZ123ABC",
    type: "jml.onboard",
    typeLabel: "Onboarding",
    status: "executing",
    priority: "p2",
    source: {
      type: "signal",
      ref: "bamboohr_webhook_abc123",
      system: "BambooHR",
      timestamp: "2026-01-15T09:00:00Z"
    },
    subject: {
      type: "user",
      id: "user_jsmith",
      name: "John Smith",
      email: "jsmith@acme.com",
      avatar: null
    },
    intent: {
      action: "onboard",
      summary: "New employee onboarding - Engineering",
      parameters: {
        department: "Engineering",
        role: "Software Engineer",
        manager: "Mary Jones",
        managerEmail: "mjones@acme.com",
        startDate: "2026-01-20",
        location: "NYC"
      }
    },
    cluster: {
      agents: ["identity_agent", "endpoint_agent", "saas_agent"],
      services: ["okta", "intune", "google_workspace", "slack", "github"],
      dependencies: [
        { name: "HR record confirmed", status: "met" },
        { name: "Manager exists", status: "met" },
        { name: "Budget approved", status: "met" }
      ]
    },
    actionBundles: ["ab_01HXYZ456DEF"],
    currentBundle: "ab_01HXYZ456DEF",
    sla: {
      target: "4h",
      deadline: "2026-01-15T13:00:00Z",
      remaining: "3h 30m",
      breached: false
    },
    createdAt: "2026-01-15T09:00:00Z",
    updatedAt: "2026-01-15T09:02:00Z"
  },
  {
    id: "case_02HXYZ456DEF",
    type: "jml.offboard",
    typeLabel: "Offboarding",
    status: "pending_approval",
    priority: "p1",
    source: {
      type: "signal",
      ref: "bamboohr_term_xyz789",
      system: "BambooHR",
      timestamp: "2026-01-15T08:30:00Z"
    },
    subject: {
      type: "user",
      id: "user_jdoe",
      name: "Jane Doe",
      email: "jdoe@acme.com",
      avatar: null
    },
    intent: {
      action: "offboard",
      summary: "Employee termination - immediate",
      parameters: {
        department: "Sales",
        lastDay: "2026-01-15",
        type: "involuntary",
        dataTransferTo: "Mike Lee"
      }
    },
    cluster: {
      agents: ["identity_agent", "endpoint_agent", "saas_agent", "security_agent"],
      services: ["okta", "intune", "google_workspace", "slack", "salesforce"],
      dependencies: [
        { name: "HR termination confirmed", status: "met" },
        { name: "Data transfer recipient", status: "met" },
        { name: "Security clearance", status: "pending" }
      ]
    },
    actionBundles: ["ab_02HXYZ789GHI"],
    currentBundle: "ab_02HXYZ789GHI",
    sla: {
      target: "2h",
      deadline: "2026-01-15T10:30:00Z",
      remaining: "1h 45m",
      breached: false
    },
    createdAt: "2026-01-15T08:30:00Z",
    updatedAt: "2026-01-15T08:45:00Z"
  },
  {
    id: "case_03HXYZ789GHI",
    type: "access.request",
    typeLabel: "Access Request",
    status: "pending_approval",
    priority: "p2",
    source: {
      type: "manual",
      ref: "slack_request_123",
      system: "Slack",
      timestamp: "2026-01-15T08:15:00Z"
    },
    subject: {
      type: "user",
      id: "user_mlee",
      name: "Mike Lee",
      email: "mlee@acme.com",
      avatar: null
    },
    intent: {
      action: "grant_access",
      summary: "Request admin access to production database",
      parameters: {
        resource: "prod_db_admin_role",
        justification: "Sprint work requires direct DB access",
        duration: "8 hours"
      }
    },
    cluster: {
      agents: ["identity_agent", "security_agent"],
      services: ["okta", "aws_rds"],
      dependencies: [
        { name: "Manager approval", status: "met" },
        { name: "Security review", status: "pending" }
      ]
    },
    actionBundles: ["ab_03HXYZ012JKL"],
    currentBundle: "ab_03HXYZ012JKL",
    sla: {
      target: "4h",
      deadline: "2026-01-15T12:15:00Z",
      remaining: "3h 30m",
      breached: false
    },
    createdAt: "2026-01-15T08:15:00Z",
    updatedAt: "2026-01-15T08:20:00Z"
  },
  {
    id: "case_04HXYZ012JKL",
    type: "endpoint.provision",
    typeLabel: "Device Provision",
    status: "verifying",
    priority: "p3",
    source: {
      type: "signal",
      ref: "intune_new_device_456",
      system: "Intune",
      timestamp: "2026-01-15T07:45:00Z"
    },
    subject: {
      type: "device",
      id: "device_laptop123",
      name: "MacBook Pro - ACME-LP-0456",
      email: null,
      avatar: null
    },
    intent: {
      action: "provision_device",
      summary: "Configure new MacBook for Sara Chen",
      parameters: {
        user: "Sara Chen",
        userEmail: "schen@acme.com",
        deviceType: "MacBook Pro 14",
        profile: "engineering-macos-standard"
      }
    },
    cluster: {
      agents: ["endpoint_agent"],
      services: ["intune", "jamf"],
      dependencies: [
        { name: "Device enrolled", status: "met" },
        { name: "User assignment", status: "met" }
      ]
    },
    actionBundles: ["ab_04HXYZ345MNO"],
    currentBundle: "ab_04HXYZ345MNO",
    sla: {
      target: "2h",
      deadline: "2026-01-15T09:45:00Z",
      remaining: "45m",
      breached: false
    },
    createdAt: "2026-01-15T07:45:00Z",
    updatedAt: "2026-01-15T08:30:00Z"
  },
  {
    id: "case_05HXYZ345MNO",
    type: "saas.reclaim",
    typeLabel: "License Reclaim",
    status: "closed",
    priority: "p3",
    source: {
      type: "scheduled",
      ref: "weekly_license_review",
      system: "Vedaya",
      timestamp: "2026-01-15T06:00:00Z"
    },
    subject: {
      type: "app",
      id: "app_figma",
      name: "Figma",
      email: null,
      avatar: null
    },
    intent: {
      action: "reclaim_licenses",
      summary: "Reclaim 12 inactive Figma seats",
      parameters: {
        seats: 12,
        inactiveDays: 90,
        monthlySavings: 180
      }
    },
    cluster: {
      agents: ["saas_agent"],
      services: ["figma"],
      dependencies: [
        { name: "Inactivity confirmed", status: "met" }
      ]
    },
    actionBundles: ["ab_05HXYZ678PQR"],
    currentBundle: "ab_05HXYZ678PQR",
    sla: {
      target: "24h",
      deadline: "2026-01-16T06:00:00Z",
      remaining: null,
      breached: false
    },
    closedAt: "2026-01-15T06:15:00Z",
    resolution: {
      outcome: "success",
      summary: "12 Figma seats reclaimed, $180/month saved"
    },
    createdAt: "2026-01-15T06:00:00Z",
    updatedAt: "2026-01-15T06:15:00Z"
  }
];

export const actionBundles = {
  "ab_01HXYZ456DEF": {
    id: "ab_01HXYZ456DEF",
    caseId: "case_01HXYZ123ABC",
    sequence: 1,
    status: "executing",
    intentSummary: "Provision standard engineering onboarding package for John Smith",
    actions: [
      {
        id: "act_001",
        agent: "identity_agent",
        connector: "okta",
        connectorIcon: "key",
        operation: "user.create",
        description: "Create user account in Okta",
        parameters: {
          email: "jsmith@acme.com",
          firstName: "John",
          lastName: "Smith",
          department: "Engineering",
          manager: "mjones@acme.com"
        },
        riskTier: "low",
        reversible: true,
        rollbackOperation: "user.deactivate",
        status: "completed",
        completedAt: "2026-01-15T09:01:45Z"
      },
      {
        id: "act_002",
        agent: "identity_agent",
        connector: "okta",
        connectorIcon: "key",
        operation: "group.add_member",
        description: "Add to engineering-standard group",
        parameters: {
          user: "jsmith@acme.com",
          group: "engineering-standard"
        },
        dependsOn: ["act_001"],
        riskTier: "low",
        reversible: true,
        status: "completed",
        completedAt: "2026-01-15T09:02:00Z"
      },
      {
        id: "act_003",
        agent: "saas_agent",
        connector: "google_workspace",
        connectorIcon: "mail",
        operation: "user.provision",
        description: "Provision Google Workspace account",
        parameters: {
          email: "jsmith@acme.com",
          orgUnit: "/Engineering",
          licenses: ["Google Workspace Business Standard"]
        },
        dependsOn: ["act_001"],
        riskTier: "low",
        reversible: true,
        estimatedCost: 12.00,
        status: "executing",
        progress: 60
      },
      {
        id: "act_004",
        agent: "endpoint_agent",
        connector: "intune",
        connectorIcon: "laptop",
        operation: "device.enroll_invite",
        description: "Send device enrollment invitation",
        parameters: {
          user: "jsmith@acme.com",
          profile: "engineering-macos-standard",
          delivery: "email"
        },
        dependsOn: ["act_001"],
        riskTier: "low",
        reversible: true,
        status: "pending"
      },
      {
        id: "act_005",
        agent: "saas_agent",
        connector: "slack",
        connectorIcon: "message-square",
        operation: "user.invite",
        description: "Invite to Slack workspace",
        parameters: {
          email: "jsmith@acme.com",
          channels: ["#engineering", "#general", "#nyc-office"]
        },
        dependsOn: ["act_001"],
        riskTier: "low",
        reversible: true,
        status: "pending"
      },
      {
        id: "act_006",
        agent: "saas_agent",
        connector: "github",
        connectorIcon: "git-branch",
        operation: "org.invite_member",
        description: "Invite to GitHub organization",
        parameters: {
          email: "jsmith@acme.com",
          teams: ["engineering"],
          role: "member"
        },
        dependsOn: ["act_001"],
        riskTier: "low",
        reversible: true,
        status: "pending"
      }
    ],
    blastRadius: {
      usersAffected: 1,
      systemsAffected: 5,
      dataScope: "single_user",
      reversibility: "full",
      estimatedDuration: "5m"
    },
    policyChecks: [
      { policy: "Standard Onboarding", result: "pass", message: "All preconditions met" },
      { policy: "Budget Check", result: "pass", message: "Monthly cost $12 within department limit" }
    ],
    approval: {
      required: false,
      reason: "All actions are low-risk and within policy bounds",
      approvers: [],
      approvedBy: null
    },
    execution: {
      startedAt: "2026-01-15T09:01:30Z",
      completedAt: null,
      mode: "execute"
    },
    createdAt: "2026-01-15T09:00:30Z"
  },
  "ab_02HXYZ789GHI": {
    id: "ab_02HXYZ789GHI",
    caseId: "case_02HXYZ456DEF",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Execute immediate offboarding for Jane Doe with data transfer",
    actions: [
      {
        id: "act_011",
        agent: "identity_agent",
        connector: "okta",
        connectorIcon: "key",
        operation: "user.deactivate",
        description: "Deactivate Okta account",
        parameters: {
          email: "jdoe@acme.com",
          immediate: true
        },
        riskTier: "medium",
        reversible: true,
        rollbackOperation: "user.reactivate",
        status: "pending"
      },
      {
        id: "act_012",
        agent: "saas_agent",
        connector: "google_workspace",
        connectorIcon: "mail",
        operation: "data.transfer",
        description: "Transfer Google Drive data to Mike Lee",
        parameters: {
          from: "jdoe@acme.com",
          to: "mlee@acme.com",
          includeEmail: true,
          includeDrive: true
        },
        riskTier: "high",
        reversible: false,
        status: "pending"
      },
      {
        id: "act_013",
        agent: "endpoint_agent",
        connector: "intune",
        connectorIcon: "laptop",
        operation: "device.wipe",
        description: "Remote wipe company device",
        parameters: {
          deviceId: "ACME-LP-0123",
          wipeType: "corporate"
        },
        riskTier: "high",
        reversible: false,
        status: "pending"
      },
      {
        id: "act_014",
        agent: "saas_agent",
        connector: "salesforce",
        connectorIcon: "database",
        operation: "user.deactivate",
        description: "Deactivate Salesforce account",
        parameters: {
          email: "jdoe@acme.com",
          transferOwnership: "mlee@acme.com"
        },
        riskTier: "medium",
        reversible: true,
        status: "pending"
      }
    ],
    blastRadius: {
      usersAffected: 2,
      systemsAffected: 4,
      dataScope: "user_data_transfer",
      reversibility: "partial",
      estimatedDuration: "15m"
    },
    policyChecks: [
      { policy: "Offboarding Compliance", result: "pass", message: "HR termination confirmed" },
      { policy: "Data Transfer", result: "pass", message: "Transfer recipient is active employee" },
      { policy: "Security Review", result: "pending", message: "Awaiting security team review" }
    ],
    approval: {
      required: true,
      reason: "High-risk actions: data transfer and device wipe",
      approvers: ["Security Team"],
      approvedBy: null,
      requestedAt: "2026-01-15T08:45:00Z"
    },
    execution: {
      startedAt: null,
      completedAt: null,
      mode: "execute"
    },
    createdAt: "2026-01-15T08:40:00Z"
  },
  "ab_03HXYZ012JKL": {
    id: "ab_03HXYZ012JKL",
    caseId: "case_03HXYZ789GHI",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Grant temporary admin access to production database for Mike Lee",
    actions: [
      {
        id: "act_021",
        agent: "identity_agent",
        connector: "okta",
        connectorIcon: "key",
        operation: "group.add_member",
        description: "Add to prod-db-admin group",
        parameters: {
          user: "mlee@acme.com",
          group: "prod-db-admin",
          expiry: "8h"
        },
        riskTier: "high",
        reversible: true,
        rollbackOperation: "group.remove_member",
        status: "pending"
      }
    ],
    blastRadius: {
      usersAffected: 1,
      systemsAffected: 1,
      dataScope: "production_data_access",
      reversibility: "full",
      estimatedDuration: "1m"
    },
    policyChecks: [
      { policy: "Privileged Access", result: "pass", message: "User is active employee" },
      { policy: "Manager Approval", result: "pass", message: "Manager Mary Jones approved" },
      { policy: "Security Review", result: "pending", message: "Awaiting security team approval" }
    ],
    approval: {
      required: true,
      reason: "High-risk: production database admin access",
      approvers: ["Mary Jones (Manager)", "Security Team"],
      approvedBy: [
        { name: "Mary Jones", at: "2026-01-15T08:20:00Z", comment: "Approved for sprint work" }
      ],
      requestedAt: "2026-01-15T08:15:00Z"
    },
    execution: {
      startedAt: null,
      completedAt: null,
      mode: "execute"
    },
    createdAt: "2026-01-15T08:15:00Z"
  }
};

export const timeline = {
  "case_01HXYZ123ABC": [
    { time: "09:00:00", event: "Signal received from BambooHR", type: "signal", icon: "zap" },
    { time: "09:00:05", event: "Case created", type: "case", icon: "file-plus" },
    { time: "09:00:10", event: "Cluster formed: identity, endpoint, saas agents", type: "cluster", icon: "users" },
    { time: "09:00:30", event: "Action bundle planned (6 actions)", type: "plan", icon: "list" },
    { time: "09:01:00", event: "Policy check passed, auto-approved", type: "policy", icon: "shield-check" },
    { time: "09:01:30", event: "Execution started", type: "execute", icon: "play" },
    { time: "09:01:45", event: "Okta user created", type: "success", icon: "check-circle", action: "act_001" },
    { time: "09:02:00", event: "Groups assigned", type: "success", icon: "check-circle", action: "act_002" },
    { time: "09:02:15", event: "Google Workspace provisioning...", type: "progress", icon: "loader", action: "act_003" }
  ],
  "case_02HXYZ456DEF": [
    { time: "08:30:00", event: "Signal received from BambooHR - Termination", type: "signal", icon: "zap" },
    { time: "08:30:05", event: "Case created - Priority P1", type: "case", icon: "file-plus" },
    { time: "08:30:10", event: "Cluster formed: identity, endpoint, saas, security agents", type: "cluster", icon: "users" },
    { time: "08:35:00", event: "Action bundle planned (4 actions)", type: "plan", icon: "list" },
    { time: "08:40:00", event: "Policy check: Security review required", type: "policy", icon: "shield" },
    { time: "08:45:00", event: "Approval requested from Security Team", type: "approval", icon: "clock" }
  ],
  "case_03HXYZ789GHI": [
    { time: "08:15:00", event: "Request received via Slack", type: "signal", icon: "zap" },
    { time: "08:15:05", event: "Case created - Access Request", type: "case", icon: "file-plus" },
    { time: "08:15:10", event: "Cluster formed: identity, security agents", type: "cluster", icon: "users" },
    { time: "08:15:30", event: "Action bundle planned (1 action)", type: "plan", icon: "list" },
    { time: "08:16:00", event: "Policy check: High-risk access detected", type: "policy", icon: "shield" },
    { time: "08:17:00", event: "Approval requested from Manager", type: "approval", icon: "clock" },
    { time: "08:20:00", event: "Manager Mary Jones approved", type: "success", icon: "check-circle" },
    { time: "08:20:05", event: "Awaiting Security Team approval", type: "approval", icon: "clock" }
  ],
  "case_04HXYZ012JKL": [
    { time: "07:45:00", event: "New device detected by Intune", type: "signal", icon: "zap" },
    { time: "07:45:05", event: "Case created - Device Provision", type: "case", icon: "file-plus" },
    { time: "07:45:10", event: "Cluster formed: endpoint agent", type: "cluster", icon: "users" },
    { time: "07:46:00", event: "Action bundle planned (3 actions)", type: "plan", icon: "list" },
    { time: "07:46:30", event: "Policy check passed, auto-approved", type: "policy", icon: "shield-check" },
    { time: "07:47:00", event: "Execution started", type: "execute", icon: "play" },
    { time: "07:50:00", event: "Device enrolled in MDM", type: "success", icon: "check-circle" },
    { time: "08:00:00", event: "Security policies applied", type: "success", icon: "check-circle" },
    { time: "08:15:00", event: "Apps installation in progress...", type: "progress", icon: "loader" }
  ]
};

export const agents = [
  {
    id: "identity_agent",
    name: "Identity Agent",
    domain: "Identity",
    status: "active",
    trust: 98.2,
    trustTrend: "up",
    actions24h: 47,
    rollbackRate: 0.6,
    cost24h: 38.40,
    drift: "none",
    connectors: ["okta", "entra_id"],
    currentCases: 3
  },
  {
    id: "endpoint_agent",
    name: "Endpoint Agent",
    domain: "Endpoints",
    status: "active",
    trust: 97.8,
    trustTrend: "stable",
    actions24h: 23,
    rollbackRate: 2.6,
    cost24h: 18.72,
    drift: "none",
    connectors: ["intune", "jamf"],
    currentCases: 2
  },
  {
    id: "saas_agent",
    name: "SaaS Agent",
    domain: "SaaS",
    status: "active",
    trust: 94.1,
    trustTrend: "down",
    actions24h: 31,
    rollbackRate: 5.6,
    cost24h: 10.68,
    drift: "warn",
    driftMessage: "Slack connector latency increased 40%",
    connectors: ["google_workspace", "slack", "github", "figma", "salesforce"],
    currentCases: 4
  },
  {
    id: "network_agent",
    name: "Network Agent",
    domain: "Network",
    status: "active",
    trust: 99.1,
    trustTrend: "up",
    actions24h: 8,
    rollbackRate: 0,
    cost24h: 5.40,
    drift: "none",
    connectors: ["cloudflare", "palo_alto"],
    currentCases: 1
  },
  {
    id: "security_agent",
    name: "Security Agent",
    domain: "Security",
    status: "active",
    trust: 99.5,
    trustTrend: "stable",
    actions24h: 12,
    rollbackRate: 0,
    cost24h: 2.76,
    drift: "none",
    connectors: ["crowdstrike", "sentinel"],
    currentCases: 2
  }
];

export const systemMetrics = {
  autonomyRate: 94,
  pendingApprovals: 2,
  failedCases: 0,
  conflicts: 1,
  cases24h: 142,
  mttr: "12m",
  cost24h: 47.20
};

export const requiresAttention = [
  {
    id: "attn_001",
    type: "approval",
    priority: "high",
    title: "Approval Needed: Admin access for Mike Lee",
    description: "Production database admin access (Security DB)",
    caseId: "case_03HXYZ789GHI",
    requestedBy: "identity_agent",
    blastRadius: "1 user",
    age: "5m"
  },
  {
    id: "attn_002",
    type: "approval",
    priority: "high",
    title: "Approval Needed: Offboard Jane Doe",
    description: "Immediate termination with data transfer",
    caseId: "case_02HXYZ456DEF",
    requestedBy: "identity_agent",
    blastRadius: "2 users, 4 systems",
    age: "15m"
  },
  {
    id: "attn_003",
    type: "conflict",
    priority: "medium",
    title: "Resource Contention",
    description: "case_xyz waiting on case_abc (same user)",
    deadlockRisk: "low",
    age: "3m"
  }
];

export const connectors = [
  { id: "okta", name: "Okta", status: "healthy", latency: 120, errorRate: 0.1 },
  { id: "entra_id", name: "Entra ID", status: "healthy", latency: 95, errorRate: 0 },
  { id: "google_workspace", name: "Google Workspace", status: "healthy", latency: 180, errorRate: 0.2 },
  { id: "intune", name: "Intune", status: "healthy", latency: 210, errorRate: 0.1 },
  { id: "slack", name: "Slack", status: "degraded", latency: 450, errorRate: 2.1 },
  { id: "github", name: "GitHub", status: "healthy", latency: 85, errorRate: 0 },
  { id: "figma", name: "Figma", status: "healthy", latency: 130, errorRate: 0.3 },
  { id: "salesforce", name: "Salesforce", status: "healthy", latency: 290, errorRate: 0.5 }
];

// Domain-specific cases for Endpoints, SaaS, Security, and Identity pages
export const domainCases = {
  // Endpoint domain cases
  "case_ep_001": {
    id: "case_ep_001",
    type: "endpoint.compliance",
    typeLabel: "Compliance Violation",
    status: "pending_approval",
    priority: "p2",
    source: { type: "signal", system: "Intune", timestamp: "2026-01-15T10:00:00Z" },
    subject: { type: "device", id: "device_lp0456", name: "ACME-LP-0456", email: "schen@acme.com" },
    intent: { action: "enforce_compliance", summary: "Enable encryption on non-compliant device", parameters: { device: "ACME-LP-0456", user: "Sara Chen", policy: "encryption-required" } },
    cluster: { agents: ["endpoint_agent"], services: ["intune"], dependencies: [{ name: "Device online", status: "met" }] },
    actionBundles: ["ab_ep_001"],
    currentBundle: "ab_ep_001",
    sla: { target: "4h", deadline: "2026-01-15T14:00:00Z", remaining: "4h", breached: false },
    createdAt: "2026-01-15T10:00:00Z",
    updatedAt: "2026-01-15T10:00:00Z"
  },
  "case_ep_002": {
    id: "case_ep_002",
    type: "endpoint.quarantine",
    typeLabel: "Quarantine Proposal",
    status: "pending_approval",
    priority: "p1",
    source: { type: "signal", system: "CrowdStrike", timestamp: "2026-01-15T09:30:00Z" },
    subject: { type: "device", id: "device_lp0789", name: "ACME-LP-0789", email: null },
    intent: { action: "quarantine_device", summary: "Isolate and wipe malware-infected device", parameters: { device: "ACME-LP-0789", threat: "Trojan detected", severity: "critical" } },
    cluster: { agents: ["endpoint_agent", "security_agent"], services: ["intune", "crowdstrike"], dependencies: [{ name: "Threat confirmed", status: "met" }] },
    actionBundles: ["ab_ep_002"],
    currentBundle: "ab_ep_002",
    sla: { target: "30m", deadline: "2026-01-15T10:00:00Z", remaining: "30m", breached: false },
    createdAt: "2026-01-15T09:30:00Z",
    updatedAt: "2026-01-15T09:30:00Z"
  },
  "case_ep_003": {
    id: "case_ep_003",
    type: "endpoint.patch",
    typeLabel: "Patch Rollout",
    status: "executing",
    priority: "p3",
    source: { type: "scheduled", system: "Vedaya", timestamp: "2026-01-15T06:00:00Z" },
    subject: { type: "fleet", id: "engineering_fleet", name: "Engineering Fleet (145 devices)" },
    intent: { action: "deploy_patch", summary: "Security patch KB2026-001 deployment", parameters: { patch: "KB2026-001", target: "Engineering macOS devices", totalDevices: 145 } },
    cluster: { agents: ["endpoint_agent"], services: ["jamf"], dependencies: [{ name: "Patch validated", status: "met" }] },
    actionBundles: ["ab_ep_003"],
    currentBundle: "ab_ep_003",
    sla: { target: "24h", deadline: "2026-01-16T06:00:00Z", remaining: "24h", breached: false },
    createdAt: "2026-01-15T06:00:00Z",
    updatedAt: "2026-01-15T08:30:00Z"
  },
  "case_ep_004": {
    id: "case_ep_004",
    type: "endpoint.enrollment",
    typeLabel: "Enrollment Drift",
    status: "pending_approval",
    priority: "p2",
    source: { type: "signal", system: "Intune", timestamp: "2026-01-15T08:00:00Z" },
    subject: { type: "fleet", id: "unmanaged_devices", name: "12 Unmanaged Devices" },
    intent: { action: "enroll_devices", summary: "Send enrollment invitations to unmanaged devices", parameters: { deviceCount: 12, action: "enroll_or_block" } },
    cluster: { agents: ["endpoint_agent"], services: ["intune"], dependencies: [{ name: "Devices identified", status: "met" }] },
    actionBundles: ["ab_ep_004"],
    currentBundle: "ab_ep_004",
    sla: { target: "8h", deadline: "2026-01-15T16:00:00Z", remaining: "8h", breached: false },
    createdAt: "2026-01-15T08:00:00Z",
    updatedAt: "2026-01-15T08:00:00Z"
  },
  // SaaS domain cases
  "case_saas_001": {
    id: "case_saas_001",
    type: "access.request",
    typeLabel: "Access Request",
    status: "pending_approval",
    priority: "p2",
    source: { type: "manual", system: "Slack", timestamp: "2026-01-15T08:00:00Z" },
    subject: { type: "user", id: "user_mlee", name: "Mike Lee", email: "mlee@acme.com" },
    intent: { action: "grant_access", summary: "Grant Salesforce Admin access for Q1 reporting", parameters: { app: "Salesforce", tier: "Admin", reason: "Q1 sales reporting" } },
    cluster: { agents: ["saas_agent", "identity_agent"], services: ["salesforce", "okta"], dependencies: [{ name: "Manager approval", status: "pending" }] },
    actionBundles: ["ab_saas_001"],
    currentBundle: "ab_saas_001",
    sla: { target: "4h", deadline: "2026-01-15T12:00:00Z", remaining: "3h", breached: false },
    createdAt: "2026-01-15T08:00:00Z",
    updatedAt: "2026-01-15T08:00:00Z"
  },
  "case_saas_002": {
    id: "case_saas_002",
    type: "access.review",
    typeLabel: "Access Review",
    status: "executing",
    priority: "p3",
    source: { type: "scheduled", system: "Vedaya", timestamp: "2026-01-15T00:00:00Z" },
    subject: { type: "app", id: "app_figma", name: "Figma" },
    intent: { action: "review_access", summary: "Quarterly Figma access review", parameters: { app: "Figma", totalUsers: 128, reviewPeriod: "Q1 2026" } },
    cluster: { agents: ["saas_agent"], services: ["figma"], dependencies: [{ name: "User list fetched", status: "met" }] },
    actionBundles: ["ab_saas_002"],
    currentBundle: "ab_saas_002",
    sla: { target: "5d", deadline: "2026-01-20T00:00:00Z", remaining: "5d", breached: false },
    createdAt: "2026-01-15T00:00:00Z",
    updatedAt: "2026-01-15T09:00:00Z"
  },
  "case_saas_003": {
    id: "case_saas_003",
    type: "access.stale",
    typeLabel: "Stale Access Removal",
    status: "pending_approval",
    priority: "p3",
    source: { type: "signal", system: "Vedaya", timestamp: "2026-01-15T06:00:00Z" },
    subject: { type: "app", id: "app_github", name: "GitHub Enterprise" },
    intent: { action: "revoke_access", summary: "Revoke stale GitHub access for 8 inactive users", parameters: { app: "GitHub Enterprise", inactiveUsers: 8, inactiveDays: 90, savings: "$800/month" } },
    cluster: { agents: ["saas_agent"], services: ["github"], dependencies: [{ name: "Inactivity confirmed", status: "met" }] },
    actionBundles: ["ab_saas_003"],
    currentBundle: "ab_saas_003",
    sla: { target: "7d", deadline: "2026-01-22T06:00:00Z", remaining: "7d", breached: false },
    createdAt: "2026-01-15T06:00:00Z",
    updatedAt: "2026-01-15T06:00:00Z"
  },
  "case_spend_001": {
    id: "case_spend_001",
    type: "saas.reclaim",
    typeLabel: "License Reclamation",
    status: "pending_approval",
    priority: "p3",
    source: { type: "scheduled", system: "Vedaya", timestamp: "2026-01-15T06:00:00Z" },
    subject: { type: "app", id: "app_figma", name: "Figma" },
    intent: { action: "reclaim_licenses", summary: "Reclaim 12 inactive Figma seats", parameters: { app: "Figma", seats: 12, inactiveDays: 90, savings: "$180/month" } },
    cluster: { agents: ["saas_agent"], services: ["figma"], dependencies: [{ name: "Inactivity confirmed", status: "met" }] },
    actionBundles: ["ab_spend_001"],
    currentBundle: "ab_spend_001",
    sla: { target: "24h", deadline: "2026-01-16T06:00:00Z", remaining: "20h", breached: false },
    createdAt: "2026-01-15T06:00:00Z",
    updatedAt: "2026-01-15T06:00:00Z"
  },
  "case_spend_002": {
    id: "case_spend_002",
    type: "saas.renewal",
    typeLabel: "Renewal Optimization",
    status: "pending_approval",
    priority: "p2",
    source: { type: "signal", system: "Vedaya", timestamp: "2026-01-15T07:00:00Z" },
    subject: { type: "app", id: "app_slack", name: "Slack" },
    intent: { action: "optimize_renewal", summary: "Right-size Slack to Business+ tier", parameters: { app: "Slack", currentSpend: "$45,000/yr", recommendation: "Business+ tier", savings: "$12,000/year" } },
    cluster: { agents: ["saas_agent"], services: ["slack"], dependencies: [{ name: "Usage analyzed", status: "met" }] },
    actionBundles: ["ab_spend_002"],
    currentBundle: "ab_spend_002",
    sla: { target: "48h", deadline: "2026-01-17T07:00:00Z", remaining: "46h", breached: false },
    createdAt: "2026-01-15T07:00:00Z",
    updatedAt: "2026-01-15T07:00:00Z"
  },
  "case_spend_003": {
    id: "case_spend_003",
    type: "saas.duplicate",
    typeLabel: "Duplicate Detection",
    status: "pending_approval",
    priority: "p3",
    source: { type: "signal", system: "Vedaya", timestamp: "2026-01-15T08:00:00Z" },
    subject: { type: "app", id: "app_miro_figjam", name: "Miro, FigJam, Lucidchart" },
    intent: { action: "consolidate_apps", summary: "Consolidate to single whiteboard tool", parameters: { apps: ["Miro", "FigJam", "Lucidchart"], recommendation: "Miro", savings: "$8,500/year" } },
    cluster: { agents: ["saas_agent"], services: ["slack", "okta"], dependencies: [{ name: "Usage overlap confirmed", status: "met" }] },
    actionBundles: ["ab_spend_003"],
    currentBundle: "ab_spend_003",
    sla: { target: "7d", deadline: "2026-01-22T08:00:00Z", remaining: "7d", breached: false },
    createdAt: "2026-01-15T08:00:00Z",
    updatedAt: "2026-01-15T08:00:00Z"
  },
  // Security domain cases
  "case_sec_001": {
    id: "case_sec_001",
    type: "security.containment",
    typeLabel: "Containment",
    status: "executing",
    priority: "p1",
    source: { type: "signal", system: "CrowdStrike", timestamp: "2026-01-15T09:45:00Z" },
    subject: { type: "user", id: "user_jdoe", name: "jdoe@acme.com", email: "jdoe@acme.com" },
    intent: { action: "contain_threat", summary: "Block suspicious login and force password reset", parameters: { threat: "Multiple failed logins from new location", actions: ["Block IP", "Force password reset", "Notify user"] } },
    cluster: { agents: ["security_agent", "identity_agent"], services: ["crowdstrike", "okta"], dependencies: [{ name: "Threat confirmed", status: "met" }] },
    actionBundles: ["ab_sec_001"],
    currentBundle: "ab_sec_001",
    sla: { target: "15m", deadline: "2026-01-15T10:00:00Z", remaining: "15m", breached: false },
    createdAt: "2026-01-15T09:45:00Z",
    updatedAt: "2026-01-15T09:45:00Z"
  },
  "case_sec_002": {
    id: "case_sec_002",
    type: "security.incident",
    typeLabel: "Security Incident",
    status: "pending_approval",
    priority: "p1",
    source: { type: "signal", system: "CrowdStrike", timestamp: "2026-01-15T09:30:00Z" },
    subject: { type: "device", id: "device_lp0789", name: "ACME-LP-0789" },
    intent: { action: "respond_incident", summary: "Quarantine malware-infected device", parameters: { threat: "Trojan detected, lateral movement possible", actions: ["Quarantine device", "Revoke all access", "Wipe device", "Create evidence pack"], blastRadius: "1 device, 1 user" } },
    cluster: { agents: ["security_agent", "endpoint_agent", "identity_agent"], services: ["crowdstrike", "intune", "okta"], dependencies: [{ name: "Malware confirmed", status: "met" }] },
    actionBundles: ["ab_sec_002"],
    currentBundle: "ab_sec_002",
    sla: { target: "30m", deadline: "2026-01-15T10:00:00Z", remaining: "30m", breached: false },
    createdAt: "2026-01-15T09:30:00Z",
    updatedAt: "2026-01-15T09:30:00Z"
  },
  "case_sec_003": {
    id: "case_sec_003",
    type: "security.policy_violation",
    typeLabel: "Policy Violation",
    status: "pending_approval",
    priority: "p2",
    source: { type: "signal", system: "Okta", timestamp: "2026-01-15T08:00:00Z" },
    subject: { type: "user", id: "users_credential_sharing", name: "3 users sharing credentials" },
    intent: { action: "remediate_violation", summary: "Force password reset and enable MFA for credential-sharing users", parameters: { threat: "Credential sharing detected via concurrent sessions", actions: ["Force password reset", "Enable MFA", "Notify managers"], blastRadius: "3 users" } },
    cluster: { agents: ["security_agent", "identity_agent"], services: ["okta"], dependencies: [{ name: "Violation confirmed", status: "met" }] },
    actionBundles: ["ab_sec_003"],
    currentBundle: "ab_sec_003",
    sla: { target: "4h", deadline: "2026-01-15T12:00:00Z", remaining: "4h", breached: false },
    createdAt: "2026-01-15T08:00:00Z",
    updatedAt: "2026-01-15T08:00:00Z"
  },
  // Identity policy violation cases
  "case_viol_001": {
    id: "case_viol_001",
    type: "identity.stale_access",
    typeLabel: "Stale Access Reclamation",
    status: "pending_approval",
    priority: "p2",
    source: { type: "signal", system: "Vedaya", timestamp: "2026-01-15T06:00:00Z" },
    subject: { type: "users", id: "stale_admin_users", name: "12 users with stale admin access" },
    intent: { action: "reclaim_access", summary: "Revoke unused admin access from 12 users", parameters: { affectedUsers: 12, inactiveDays: 90, accessType: "admin" } },
    cluster: { agents: ["identity_agent"], services: ["okta"], dependencies: [{ name: "Inactivity confirmed", status: "met" }] },
    actionBundles: ["ab_viol_001"],
    currentBundle: "ab_viol_001",
    sla: { target: "24h", deadline: "2026-01-16T06:00:00Z", remaining: "20h", breached: false },
    createdAt: "2026-01-15T06:00:00Z",
    updatedAt: "2026-01-15T06:00:00Z"
  },
  "case_viol_002": {
    id: "case_viol_002",
    type: "identity.orphaned_account",
    typeLabel: "Orphaned Account Investigation",
    status: "pending_approval",
    priority: "p1",
    source: { type: "signal", system: "Vedaya", timestamp: "2026-01-15T06:00:00Z" },
    subject: { type: "users", id: "orphaned_accounts", name: "3 accounts with no HR record" },
    intent: { action: "investigate_accounts", summary: "Investigate and deactivate orphaned accounts", parameters: { affectedUsers: 3, issue: "No matching HR record" } },
    cluster: { agents: ["identity_agent", "security_agent"], services: ["okta", "bamboohr"], dependencies: [{ name: "HR mismatch confirmed", status: "met" }] },
    actionBundles: ["ab_viol_002"],
    currentBundle: "ab_viol_002",
    sla: { target: "4h", deadline: "2026-01-15T10:00:00Z", remaining: "4h", breached: false },
    createdAt: "2026-01-15T06:00:00Z",
    updatedAt: "2026-01-15T06:00:00Z"
  },
  "case_viol_003": {
    id: "case_viol_003",
    type: "identity.missing_mfa",
    typeLabel: "MFA Enforcement",
    status: "pending_approval",
    priority: "p1",
    source: { type: "signal", system: "Okta", timestamp: "2026-01-15T06:00:00Z" },
    subject: { type: "users", id: "no_mfa_users", name: "8 privileged users without MFA" },
    intent: { action: "enforce_mfa", summary: "Enable MFA for 8 privileged users", parameters: { affectedUsers: 8, issue: "MFA not enabled for privileged accounts" } },
    cluster: { agents: ["identity_agent", "security_agent"], services: ["okta"], dependencies: [{ name: "Privileged status confirmed", status: "met" }] },
    actionBundles: ["ab_viol_003"],
    currentBundle: "ab_viol_003",
    sla: { target: "2h", deadline: "2026-01-15T08:00:00Z", remaining: "2h", breached: false },
    createdAt: "2026-01-15T06:00:00Z",
    updatedAt: "2026-01-15T06:00:00Z"
  },
  "case_conflict_001": {
    id: "case_conflict_001",
    type: "conflict.resolution",
    typeLabel: "Resource Contention",
    status: "pending_approval",
    priority: "p2",
    source: { type: "signal", system: "Vedaya", timestamp: "2026-01-15T11:00:00Z" },
    subject: { type: "user", id: "user_jsmith", name: "John Smith" },
    intent: { action: "resolve_conflict", summary: "Resolve lock contention on user profile", parameters: { conflict: "Parallel modifications by Identity and SaaS agents", resolution: "Serialize updates" } },
    cluster: { agents: ["identity_agent", "saas_agent"], services: ["okta", "salesforce"], dependencies: [{ name: "Lock identified", status: "met" }] },
    actionBundles: ["ab_conflict_001"],
    currentBundle: "ab_conflict_001",
    sla: { target: "1h", deadline: "2026-01-15T12:00:00Z", remaining: "55m", breached: false },
    createdAt: "2026-01-15T11:00:00Z",
    updatedAt: "2026-01-15T11:00:00Z"
  }
};

// Domain-specific action bundles
export const domainActionBundles = {
  "ab_ep_001": {
    id: "ab_ep_001",
    caseId: "case_ep_001",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Enable FileVault encryption on ACME-LP-0456",
    actions: [
      { id: "act_ep_001", agent: "endpoint_agent", connector: "intune", operation: "policy.apply", description: "Apply encryption policy", parameters: { device: "ACME-LP-0456", policy: "filevault-enable" }, riskTier: "medium", reversible: true, rollbackOperation: "policy.revert", status: "pending" }
    ],
    blastRadius: { usersAffected: 1, systemsAffected: 1, dataScope: "single_device", reversibility: "full", estimatedDuration: "30m" },
    policyChecks: [{ policy: "Compliance Enforcement", result: "pass", message: "Policy approved for compliance violation" }],
    approval: { required: true, reason: "Device policy change requires approval", approvers: ["IT Operations"], approvedBy: null },
    createdAt: "2026-01-15T10:00:00Z"
  },
  "ab_ep_002": {
    id: "ab_ep_002",
    caseId: "case_ep_002",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Isolate and wipe malware-infected device ACME-LP-0789",
    actions: [
      { id: "act_ep_002a", agent: "endpoint_agent", connector: "intune", operation: "device.quarantine", description: "Network isolate device", parameters: { device: "ACME-LP-0789" }, riskTier: "high", reversible: true, status: "pending" },
      { id: "act_ep_002b", agent: "endpoint_agent", connector: "intune", operation: "device.wipe", description: "Remote wipe device", parameters: { device: "ACME-LP-0789", wipeType: "full" }, riskTier: "high", reversible: false, status: "pending" }
    ],
    blastRadius: { usersAffected: 1, systemsAffected: 1, dataScope: "single_device", reversibility: "partial", estimatedDuration: "15m" },
    policyChecks: [{ policy: "Security Response", result: "pass", message: "Malware threat confirmed by CrowdStrike" }],
    approval: { required: true, reason: "High-risk: device wipe is irreversible", approvers: ["Security Team"], approvedBy: null },
    createdAt: "2026-01-15T09:30:00Z"
  },
  "ab_ep_003": {
    id: "ab_ep_003",
    caseId: "case_ep_003",
    sequence: 1,
    status: "executing",
    intentSummary: "Deploy security patch KB2026-001 to Engineering fleet",
    actions: [
      { id: "act_ep_003", agent: "endpoint_agent", connector: "jamf", operation: "patch.deploy", description: "Deploy KB2026-001 to macOS devices", parameters: { patch: "KB2026-001", targetGroup: "Engineering", totalDevices: 145 }, riskTier: "low", reversible: true, status: "executing", progress: 61 }
    ],
    blastRadius: { usersAffected: 145, systemsAffected: 145, dataScope: "fleet", reversibility: "full", estimatedDuration: "4h" },
    policyChecks: [{ policy: "Patch Validation", result: "pass", message: "Patch tested on canary group" }],
    approval: { required: false, reason: "Low-risk patch deployment auto-approved" },
    createdAt: "2026-01-15T06:00:00Z"
  },
  "ab_ep_004": {
    id: "ab_ep_004",
    caseId: "case_ep_004",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Send MDM enrollment invitations to 12 unmanaged devices",
    actions: [
      { id: "act_ep_004", agent: "endpoint_agent", connector: "intune", operation: "device.enroll_invite", description: "Send enrollment invitations", parameters: { deviceCount: 12, delivery: "email" }, riskTier: "low", reversible: true, status: "pending" }
    ],
    blastRadius: { usersAffected: 12, systemsAffected: 12, dataScope: "multiple_devices", reversibility: "full", estimatedDuration: "5m" },
    policyChecks: [{ policy: "Device Management", result: "pass", message: "Unmanaged devices identified" }],
    approval: { required: true, reason: "Enrollment affects multiple devices", approvers: ["IT Operations"], approvedBy: null },
    createdAt: "2026-01-15T08:00:00Z"
  },
  "ab_saas_001": {
    id: "ab_saas_001",
    caseId: "case_saas_001",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Grant Salesforce Admin access to Mike Lee",
    actions: [
      { id: "act_saas_001", agent: "saas_agent", connector: "salesforce", operation: "permission.grant", description: "Grant Admin permission set", parameters: { user: "mlee@acme.com", permissionSet: "Admin", duration: "30d" }, riskTier: "high", reversible: true, rollbackOperation: "permission.revoke", status: "pending" }
    ],
    blastRadius: { usersAffected: 1, systemsAffected: 1, dataScope: "single_user", reversibility: "full", estimatedDuration: "2m" },
    policyChecks: [{ policy: "Access Request", result: "pending", message: "Awaiting manager and app owner approval" }],
    approval: { required: true, reason: "Admin access requires dual approval", approvers: ["Manager", "App Owner"], approvedBy: null },
    createdAt: "2026-01-15T08:00:00Z"
  },
  "ab_saas_002": {
    id: "ab_saas_002",
    caseId: "case_saas_002",
    sequence: 1,
    status: "executing",
    intentSummary: "Quarterly Figma access review - 45/128 reviewed",
    actions: [
      { id: "act_saas_002", agent: "saas_agent", connector: "figma", operation: "access.review", description: "Review user access", parameters: { app: "Figma", totalUsers: 128, reviewed: 45, flagged: 12 }, riskTier: "low", reversible: true, status: "executing", progress: 35 }
    ],
    blastRadius: { usersAffected: 128, systemsAffected: 1, dataScope: "app_users", reversibility: "full", estimatedDuration: "5d" },
    policyChecks: [{ policy: "Quarterly Review", result: "pass", message: "Scheduled review initiated" }],
    approval: { required: false, reason: "Review process auto-approved" },
    createdAt: "2026-01-15T00:00:00Z"
  },
  "ab_saas_003": {
    id: "ab_saas_003",
    caseId: "case_saas_003",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Revoke GitHub Enterprise access for 8 inactive users",
    actions: [
      { id: "act_saas_003", agent: "saas_agent", connector: "github", operation: "user.deprovision", description: "Revoke access for inactive users", parameters: { app: "GitHub Enterprise", users: 8, inactiveDays: 90 }, riskTier: "medium", reversible: true, rollbackOperation: "user.provision", status: "pending" }
    ],
    blastRadius: { usersAffected: 8, systemsAffected: 1, dataScope: "multiple_users", reversibility: "full", estimatedDuration: "5m" },
    policyChecks: [{ policy: "Stale Access", result: "pass", message: "90+ days inactivity confirmed" }],
    approval: { required: true, reason: "Access revocation requires approval", approvers: ["IT Operations"], approvedBy: null },
    createdAt: "2026-01-15T06:00:00Z"
  },
  "ab_spend_001": {
    id: "ab_spend_001",
    caseId: "case_spend_001",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Reclaim 12 inactive Figma seats - $180/month savings",
    actions: [
      { id: "act_spend_001", agent: "saas_agent", connector: "figma", operation: "license.reclaim", description: "Reclaim inactive licenses", parameters: { app: "Figma", seats: 12, savings: "$180/month" }, riskTier: "low", reversible: true, status: "pending" }
    ],
    blastRadius: { usersAffected: 12, systemsAffected: 1, dataScope: "licenses", reversibility: "full", estimatedDuration: "5m" },
    policyChecks: [{ policy: "License Optimization", result: "pass", message: "Inactivity threshold met" }],
    approval: { required: true, reason: "License changes require approval", approvers: ["Finance"], approvedBy: null },
    createdAt: "2026-01-15T06:00:00Z"
  },
  "ab_spend_002": {
    id: "ab_spend_002",
    caseId: "case_spend_002",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Right-size Slack subscription - $12,000/year savings",
    actions: [
      { id: "act_spend_002", agent: "saas_agent", connector: "slack", operation: "subscription.modify", description: "Downgrade to Business+ tier", parameters: { app: "Slack", currentTier: "Enterprise Grid", targetTier: "Business+", savings: "$12,000/year" }, riskTier: "medium", reversible: true, status: "pending" }
    ],
    blastRadius: { usersAffected: 0, systemsAffected: 1, dataScope: "subscription", reversibility: "full", estimatedDuration: "N/A" },
    policyChecks: [{ policy: "Renewal Optimization", result: "pass", message: "Usage analysis supports downgrade" }],
    approval: { required: true, reason: "Subscription change requires Finance approval", approvers: ["Finance", "IT Operations"], approvedBy: null },
    createdAt: "2026-01-15T07:00:00Z"
  },
  "ab_spend_003": {
    id: "ab_spend_003",
    caseId: "case_spend_003",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Consolidate whiteboard tools - $8,500/year savings",
    actions: [
      { id: "act_spend_003a", agent: "saas_agent", connector: "okta", operation: "app.restrict", description: "Restrict access to FigJam and Lucidchart", parameters: { apps: ["FigJam", "Lucidchart"], exceptionGroup: "whiteboard-migration-pending" }, riskTier: "medium", reversible: true, status: "pending" },
      { id: "act_spend_003b", agent: "saas_agent", connector: "slack", operation: "message.send", description: "Notify affected users of migration", parameters: { users: "affected_users", message: "Whiteboard tool consolidation" }, riskTier: "low", reversible: false, status: "pending" }
    ],
    blastRadius: { usersAffected: 89, systemsAffected: 2, dataScope: "app_access", reversibility: "partial", estimatedDuration: "N/A" },
    policyChecks: [{ policy: "Tool Consolidation", result: "pass", message: "Approved redundancy reduction initiative" }],
    approval: { required: true, reason: "Bloat reduction requires IT Ops approval", approvers: ["IT Operations"], approvedBy: null },
    createdAt: "2026-01-15T08:00:00Z"
  },
  "ab_sec_001": {
    id: "ab_sec_001",
    caseId: "case_sec_001",
    sequence: 1,
    status: "executing",
    intentSummary: "Contain suspicious login attempt for jdoe@acme.com",
    actions: [
      { id: "act_sec_001a", agent: "security_agent", connector: "crowdstrike", operation: "ip.block", description: "Block suspicious IP", parameters: { ip: "203.0.113.42", duration: "24h" }, riskTier: "low", reversible: true, status: "completed" },
      { id: "act_sec_001b", agent: "identity_agent", connector: "okta", operation: "password.reset", description: "Force password reset", parameters: { user: "jdoe@acme.com" }, riskTier: "low", reversible: false, status: "executing" },
      { id: "act_sec_001c", agent: "saas_agent", connector: "slack", operation: "message.send", description: "Notify user via Slack", parameters: { user: "jdoe@acme.com", message: "Security alert" }, riskTier: "low", reversible: false, status: "pending" }
    ],
    blastRadius: { usersAffected: 1, systemsAffected: 2, dataScope: "single_user", reversibility: "partial", estimatedDuration: "5m" },
    policyChecks: [{ policy: "Threat Response", result: "pass", message: "Auto-approved for low-risk containment" }],
    approval: { required: false, reason: "Low-risk containment auto-executed" },
    createdAt: "2026-01-15T09:45:00Z"
  },
  "ab_sec_002": {
    id: "ab_sec_002",
    caseId: "case_sec_002",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Respond to malware incident on ACME-LP-0789",
    actions: [
      { id: "act_sec_002a", agent: "endpoint_agent", connector: "intune", operation: "device.quarantine", description: "Quarantine infected device", parameters: { device: "ACME-LP-0789" }, riskTier: "high", reversible: true, status: "pending" },
      { id: "act_sec_002b", agent: "identity_agent", connector: "okta", operation: "user.deactivate", description: "Revoke all user access", parameters: { user: "unknown" }, riskTier: "high", reversible: true, status: "pending" },
      { id: "act_sec_002c", agent: "endpoint_agent", connector: "intune", operation: "device.wipe", description: "Remote wipe device", parameters: { device: "ACME-LP-0789", wipeType: "full" }, riskTier: "high", reversible: false, status: "pending" },
      { id: "act_sec_002d", agent: "security_agent", connector: "crowdstrike", operation: "evidence.package", description: "Create evidence package", parameters: { incidentId: "INC-2026-0115", includeTimeline: true }, riskTier: "low", reversible: false, status: "pending" }
    ],
    blastRadius: { usersAffected: 1, systemsAffected: 3, dataScope: "single_device", reversibility: "partial", estimatedDuration: "20m" },
    policyChecks: [{ policy: "Incident Response", result: "pass", message: "Malware confirmed by CrowdStrike" }],
    approval: { required: true, reason: "High-risk actions: device wipe is irreversible", approvers: ["Security Team"], approvedBy: null },
    createdAt: "2026-01-15T09:30:00Z"
  },
  "ab_sec_003": {
    id: "ab_sec_003",
    caseId: "case_sec_003",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Remediate credential sharing for 3 users",
    actions: [
      { id: "act_sec_003a", agent: "identity_agent", connector: "okta", operation: "password.reset", description: "Force password reset for affected users", parameters: { users: 3 }, riskTier: "low", reversible: false, status: "pending" },
      { id: "act_sec_003b", agent: "identity_agent", connector: "okta", operation: "mfa.enable", description: "Enable MFA for affected users", parameters: { users: 3, mfaType: "push" }, riskTier: "low", reversible: true, status: "pending" },
      { id: "act_sec_003c", agent: "saas_agent", connector: "slack", operation: "message.send", description: "Notify managers", parameters: { managers: 2, message: "Credential sharing policy violation" }, riskTier: "low", reversible: false, status: "pending" }
    ],
    blastRadius: { usersAffected: 3, systemsAffected: 2, dataScope: "multiple_users", reversibility: "partial", estimatedDuration: "10m" },
    policyChecks: [{ policy: "Security Policy", result: "pass", message: "Credential sharing confirmed via logs" }],
    approval: { required: true, reason: "Policy remediation requires approval", approvers: ["Security Team"], approvedBy: null },
    createdAt: "2026-01-15T08:00:00Z"
  },
  "ab_viol_001": {
    id: "ab_viol_001",
    caseId: "case_viol_001",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Revoke stale admin access from 12 users",
    actions: [
      { id: "act_viol_001", agent: "identity_agent", connector: "okta", operation: "group.remove_members", description: "Remove from admin groups", parameters: { users: 12, groups: ["admin-standard", "admin-privileged"] }, riskTier: "medium", reversible: true, status: "pending" }
    ],
    blastRadius: { usersAffected: 12, systemsAffected: 1, dataScope: "multiple_users", reversibility: "full", estimatedDuration: "5m" },
    policyChecks: [{ policy: "Access Governance", result: "pass", message: "90+ days inactivity confirmed" }],
    approval: { required: true, reason: "Bulk access changes require approval", approvers: ["IT Operations"], approvedBy: null },
    createdAt: "2026-01-15T06:00:00Z"
  },
  "ab_viol_002": {
    id: "ab_viol_002",
    caseId: "case_viol_002",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Investigate and deactivate 3 orphaned accounts",
    actions: [
      { id: "act_viol_002", agent: "identity_agent", connector: "okta", operation: "user.deactivate", description: "Deactivate orphaned accounts", parameters: { users: 3, reason: "No HR record match" }, riskTier: "high", reversible: true, status: "pending" }
    ],
    blastRadius: { usersAffected: 3, systemsAffected: 1, dataScope: "multiple_users", reversibility: "full", estimatedDuration: "5m" },
    policyChecks: [{ policy: "Identity Governance", result: "pass", message: "No matching HR records found" }],
    approval: { required: true, reason: "Account deactivation requires approval", approvers: ["HR", "Security Team"], approvedBy: null },
    createdAt: "2026-01-15T06:00:00Z"
  },
  "ab_viol_003": {
    id: "ab_viol_003",
    caseId: "case_viol_003",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Enable MFA for 8 privileged users",
    actions: [
      { id: "act_viol_003", agent: "identity_agent", connector: "okta", operation: "mfa.enforce", description: "Enforce MFA for privileged users", parameters: { users: 8, mfaType: "push", deadline: "24h" }, riskTier: "low", reversible: true, status: "pending" }
    ],
    blastRadius: { usersAffected: 8, systemsAffected: 1, dataScope: "multiple_users", reversibility: "full", estimatedDuration: "5m" },
    policyChecks: [{ policy: "Security Policy", result: "pass", message: "Privileged accounts must have MFA" }],
    approval: { required: true, reason: "MFA enforcement requires approval", approvers: ["Security Team"], approvedBy: null },
    createdAt: "2026-01-15T06:00:00Z"
  },
  "ab_conflict_001": {
    id: "ab_conflict_001",
    caseId: "case_conflict_001",
    sequence: 1,
    status: "pending_approval",
    intentSummary: "Serialize updates to resolve contention",
    actions: [
      { id: "act_conflict_001", agent: "identity_agent", connector: "okta", operation: "lock.acquire", description: "Acquire exclusive lock on user profile", parameters: { user: "jsmith@acme.com", ttl: "30s" }, riskTier: "low", reversible: true, status: "pending" },
      { id: "act_conflict_002", agent: "saas_agent", connector: "salesforce", operation: "user.update", description: "Retry Salesforce update", parameters: { user: "jsmith@acme.com", field: "department" }, riskTier: "low", reversible: true, status: "pending" }
    ],
    blastRadius: { usersAffected: 1, systemsAffected: 2, dataScope: "single_user", reversibility: "full", estimatedDuration: "1m" },
    policyChecks: [{ policy: "Conflict Resolution", result: "pass", message: "Serialization strategy approved" }],
    approval: { required: true, reason: "Manual intervention for deadlock", approvers: ["IT Operations"], approvedBy: null },
    createdAt: "2026-01-15T11:00:00Z"
  }
};

// Helper function to get case by ID (checks both main cases and domain cases)
export const getCaseById = (caseId) => {
  const mainCase = cases.find(c => c.id === caseId);
  if (mainCase) return mainCase;
  return domainCases[caseId] || null;
};

// Helper function to get action bundle by ID (checks both main bundles and domain bundles)
export const getActionBundleById = (bundleId) => {
  if (actionBundles[bundleId]) return actionBundles[bundleId];
  return domainActionBundles[bundleId] || null;
};
